import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import UtilityService from "../../services/UtillityServices/UtilityService";

/**
 * Colonna Stato in Gestione utenti: testo Attivo/In attesa + dettaglio bounce in modale
 * (tap/click: adatto a mobile, niente tooltip hover-only).
 */
const StatoUtenteConBounceCell = ({ abilitatoWeb, row }) => {
  const statoText = abilitatoWeb == "1" ? "Attivo" : "In attesa";
  const bounce = UtilityService.getEmailConsegnaAlert(row);
  const [open, setOpen] = useState(false);

  if (!bounce) {
    return <span>{statoText}</span>;
  }

  const isDanger = bounce.variant === "danger";

  return (
    <div className="d-flex flex-column align-items-stretch gap-1" style={{ minWidth: "6.5rem", maxWidth: "100%" }}>
      <span>{statoText}</span>
      <Button
        type="button"
        variant={isDanger ? "outline-danger" : "outline-warning"}
        size="sm"
        className="d-inline-flex align-items-center justify-content-start text-start py-1 px-2 w-100"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Apri dettaglio problema di recapito email"
      >
        <i className="bi bi-envelope-exclamation me-1 flex-shrink-0" aria-hidden="true" />
        <span className="small">Problema email</span>
      </Button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        centered
        scrollable
        size="lg"
        fullscreen="sm-down"
        enforceFocus
      >
        <Modal.Header closeButton>
          <Modal.Title as="h2" className="h5 mb-0 pe-2">
            {bounce.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0 text-break" style={{ whiteSpace: "pre-wrap" }}>
            {bounce.text}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setOpen(false)} className="w-100 w-sm-auto">
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StatoUtenteConBounceCell;
